import React from 'react';
import './credits.scss';

export const Credits: React.FC = () =>
  <p className='credits'>
    Made with <span role='img' aria-label='love'>❤️</span> by Campbell Pedersen
  </p>;